import { render, staticRenderFns } from "./associateData.vue?vue&type=template&id=21c60b05&scoped=true"
import script from "./associateData.vue?vue&type=script&lang=js"
export * from "./associateData.vue?vue&type=script&lang=js"
import style0 from "./associateData.vue?vue&type=style&index=0&id=21c60b05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c60b05",
  null
  
)

export default component.exports